import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import { base64logo, base64watermark } from "./BaseImages";

Font.register({
  family: "Roboto",
  fonts: [
    { src: "http://fonts.gstatic.com/s/roboto/v15/W5F8_SL0XFawnjxHGsZjJA.ttf" },
    {
      src: "http://fonts.gstatic.com/s/roboto/v15/bdHGHleUa-ndQCOrdpfxfw.ttf",
      fontStyle: "normal",
      fontWeight: 700,
    },
  ],
});

// Definir los estilos
const styles = StyleSheet.create({
  page: {
    fontSize: 12,
    color: "#454546",
    height: "100%",
  },
  header: {
    paddingHorizontal: 40,
    paddingTop: 40,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },

  logo: {
    width: "auto",
    height: 64, // Reduce from 64 to 50
  },

  // Update the headerright style
  headerright: {
    width: "auto",
    height: 45, // Reduce from 25% to 10%
  },
  title: {
    textAlign: "center",
    fontSize: 16,
    fontFamily: "Roboto",
    fontWeight: 700,
    color: "#000",
    marginBottom: 20,
  },
  section: {
    paddingHorizontal: 40,
    marginBottom: 10,
  },
  textBold: {
    color: "#000",
    fontSize: 12,
    fontFamily: "Roboto",
  },
  text: {
    marginBottom: 5,
    fontSize: 12,
    fontFamily: "Roboto",
  },
  footerImage: {
    width: "100%",
    height: "8%",
    position: "absolute",
    bottom: 0,
    zIndex: -1, // Añadido para asegurar que esté detrás de otros elementos
  },
  watermark: {
    position: "absolute",
    top: "35%",
    left: "15%",
    width: "70%",
    opacity: 0.04,
    zIndex: "-10",
  },
  gridContainer: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 50,
    marginBottom: 20,
  },
  gridItem: {
    width: "48%", // two items per row, with some space between
    marginBottom: 5,
  },
  singleItem: {
    width: "100%",
  },
  information: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 40,
    marginBottom: 10,
  },
  image: {
    width: 100,
    height: 100,
  },

  firmas: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: 20,
    position: "absolute",
    bottom: 80,
  },
  columDr: {
    flex: 1,
    // backgroundColor: "yellow",
    textAlign: "center",
    marginLeft: 20,
  },
  firma: {
    width: "25%",
    marginLeft: "38%",
  },
});

const OrdenPdf = ({ data }) => {
  const orden = [];
  const archivos = data?.orden?.archivos;
  if (data.orden.tipo !== "Analisis de Gabinete")
    Object.keys(data.orden).forEach((key) => {
      if (
        data?.orden[key] &&
        !key.includes("resultado") &&
        !key.includes("_at") &&
        key !== "nombre" &&
        key !== "tipo" &&
        key !== "id" &&
        key !== "cita_id" &&
        key !== "archivos" &&
        key !== "modulo_ubicacion" &&
        key !== "patient_id"
      ) {
        orden.push(key.replaceAll("_", " ").toUpperCase());
      }
    });

  return (
    <Document>
      <Page style={styles.page}>
        <Image fixed style={styles.watermark} src="/images/watermark.jpg" />
        <View fixed style={styles.header}>
          <Image style={styles.logo} src="/images/logoderecho.jpg" />
          <Image style={styles.headerright} src="/images/headerright.png" />
        </View>
        {/* Title */}
        {data?.orden?.tipo === "Analisis de Gabinete" ? (
          <Text style={styles.title}>ORDEN DE {data?.orden?.nombre}</Text>
        ) : (
          <Text style={styles.title}>ORDEN DE ESTUDIO DE LABORATORIO</Text>
        )}
        {/* Patient Information */}
        <View style={styles.information}>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Nombre:</Text> {data?.nombre}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Edad:</Text> {data?.edad}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Lugar de atención:</Text>{" "}
              {data?.lugarAtencion}
            </Text>
          </View>
          <View style={styles.gridItem}>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Fecha:</Text> {data?.fecha}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Seguro:</Text> {data?.seguro}
            </Text>
            {data?.orden?.tipo && (
              <Text style={styles.text}>
                <Text style={styles.textBold}>Tipo:</Text> {data?.orden?.tipo}
              </Text>
            )}
          </View>
        </View>

        {/* Receta Details */}
        <View style={styles.section}>
          <Text style={styles.text}>
            <Text style={styles.textBold}></Text>
          </Text>

          {orden.length > 0 ? (
            orden.map((val, index) => (
              <View style={styles.section} key={val}>
                <Text style={styles.text}>{`${index + 1}). ${val}`}</Text>
              </View>
            ))
          ) : (
            <View style={styles.section}>
              <Text style={styles.text}>
                <Text style={styles.textBold}>Nombre:</Text>{" "}
                {data?.orden?.nombre}
              </Text>
              <Text style={styles.text}>
                <Text style={styles.textBold}>Descripción:</Text>{" "}
                {data?.orden?.descripcion}
              </Text>
            </View>
          )}
          {archivos?.split(",").map((archivo) => (
            <Image
              src={{
                uri: archivo,
                method: "GET",
                headers: { "Cache-Control": "no-cache" },
                body: "",
              }}
              style={styles.image}
            />
          ))}
        </View>

        {/* Firmas */}
        <View style={styles.firmas}>
          <View style={styles.columDr}>
            <Image style={styles.firma} src="/images/firma.png" />
            <Text style={styles.text}>______________________</Text>
            <Text style={styles.text}>{data?.doctor?.printer_name}</Text>
            <Text style={styles.text}>{data?.doctor?.specialty}</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default OrdenPdf;
